import React, {createContext , useContext , useState} from 'react';
import { getLocalTodayString } from '../../../components/CreationDate';

const CreateAndUpdateRotaContext = createContext();

export const CreateAndUpdateRotaProvider = ({ children }) => {
    const [selectedDate, setSelectedDate] = useState(getLocalTodayString());


    return (
        <CreateAndUpdateRotaContext.Provider value={{ selectedDate, setSelectedDate }}>
            {children}
        </CreateAndUpdateRotaContext.Provider>
    )
}

export const useCreateAndUpdateRotaContext = () => useContext(CreateAndUpdateRotaContext);